import _slicedToArray from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useState } from 'react';
import { useMapContext } from '@uiw/react-baidu-map-map';
import { useProperties, useVisiable } from '@uiw/react-baidu-map-utils';
export function useCopyrightControl(props) {
  if (props === void 0) {
    props = {};
  }

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      copyrightControl = _useState2[0],
      setCopyrightControl = _useState2[1];

  var _props = props,
      anchor = _props.anchor,
      offset = _props.offset;

  var _useMapContext = useMapContext(),
      map = _useMapContext.map;

  useEffect(function () {
    if (map && !copyrightControl) {
      var instance = new BMap.CopyrightControl({
        anchor: anchor || BMAP_ANCHOR_TOP_RIGHT,
        offset: offset
      });
      map.addControl(instance);
      setCopyrightControl(instance);
    }

    return function () {
      if (map && copyrightControl) {
        map.removeControl(copyrightControl);
      }
    };
  }, [map, copyrightControl, anchor, offset]);
  useVisiable(copyrightControl, props);
  useProperties(copyrightControl, props, ['Anchor', 'Offset']);
  return {
    copyrightControl: copyrightControl,
    setCopyrightControl: setCopyrightControl
  };
}